import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Button, Card, Col, Container, Form, Modal, Row } from 'react-bootstrap'
import 'react-day-picker/dist/style.css'
import { useNavigate, useParams } from 'react-router-dom'
import { downloadSurveyPdf } from '../helpers/surveyPdf'
import KAccess from '../components/KAccess'
import KButton from '../components/KButton'
import KLayerNavigation from '../components/KLayerNavigation'
import KycCkecks from '../components/KycChecks'
import KDayPicker from '../components/KDayPicker'
import {
  canEditKycForms,
  formatDDMMYYYY,
  getAccessToken,
  getCompanyInfo,
  getDataSecurityCompanyName,
  isPiiEncryptionEnabled,
  isUserLoggedIn,
  sanitizeDDMMYYYYInput,
  setAccessToken,
  setUserAccess,
  showKAlert,
} from '../helpers'
import { getKycCheckVariant } from '../helpers/stammdaten.helper'
import { downloadKycFile } from '../helpers/downloadKycFile'
import { t } from '../locale'
import {
  BeneficialOwner,
  Client,
  ClientInfo,
  RelatedCompany,
  RepresentativeNaturalPerson,
} from '../react-app-env'
import {
  clearKycCheckCache,
  createIdentityRequestService,
  deleteIdentityRequestService,
  fetchAccess,
  fetchClientById,
  fetchIdentityParams,
  getKycCheckClientInfo,
  performKycCheckOne,
  validatePinCode,
} from '../service/client'
import {
  addBeneficialOwner,
  addRelatedCompany,
  addRepresentative,
  deleteBeneficialOwner,
  deleteRelatedCompany,
  deleteRepresentative,
  getClientInfo,
  updateBeneficialOwner,
  updateClientInfo,
  updateRelatedCompany,
  updateRepresentative,
} from '../service/clientInfo'
import { getLegalForms } from '../service/stammdaten'
import { getCountries } from '../service/country'
import IdentityModal from '../components/KModal'

export default function SurveyFormCompany() {
  const navigate = useNavigate()
  const { clientId } = useParams()

  const canEdit = canEditKycForms()
  const surveyPdfRef = useRef<HTMLFieldSetElement>(null)

  const [client, setClient] = useState<Client | null>(null)
  const [clientInfo, setClientInfo] = useState<ClientInfo | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [showModal, setShowModal] = useState(false)
  const representatives = clientInfo?.contractualPartner?.representatives || {}
  const relatedCompanies = clientInfo?.contractualPartner?.relatedCompanies || {}
  const beneficialOwnersLegalEntities = clientInfo?.beneficialOwners?.legalEntities || {}
  const beneficialOwnersFoundations = clientInfo?.beneficialOwners?.foundationsLegalCapacity || {}
  const beneficialOwnersInstigationPersons = clientInfo?.beneficialOwners?.instigationPersons || {}
  const hasRepresentatives = Object.keys(representatives).length > 0
  const hasRelatedCompanies = Object.keys(relatedCompanies).length > 0
  const hasBeneficialOwnersLegalEntities = Object.keys(beneficialOwnersLegalEntities).length > 0
  const hasBeneficialOwnersFoundations = Object.keys(beneficialOwnersFoundations).length > 0
  const hasBeneficialOwnersInstigationPersons =
    Object.keys(beneficialOwnersInstigationPersons).length > 0
  const [formData, setFormData] = useState({
    id: '',
    dataCollected: false,
    newAssessment: false,
    name: '',
    legalForm: '',
    registerType: '',
    registerNumber: '',
    gericht: '',
    address: '',
    extractFromCommerical: false,
    foundingDocuments: false,
    ownDocumented: false,
    otherDocuments: false,
    idProof: false,
    electronicIdProof: false,
    otherProof: false,
    shareHolder: '',
    shareHolderFoundations: '',
    beneficialOwners: {
      type: null,
      legalEntities: {},
      foundationsLegalCapacity: {},
      instigationPersons: {},
      naturalPersonRoles: {
        admin: false,
        management_board: false,
        beneficiary: false,
        assets_distributed: false,
        other: false,
      },
    },
    noOneConnected: false,
    closeToPolitically: false,
    preciseDesignation: '',
    notEstablishedInHighRiskCountry: false,
    establishedInHighRiskCountry: false,
    thirdCountry: '',
    purposeAndNatureClear: false,
    purposeAndNatureDescription: false,
    purposeFurtherInfo: '',
    furtherInfo: '',
    noLegalEntityAdded: false,
    beneficialOwnerSelection: '',
    isFinished: false,
  })
  const [legalForms, setLegalForms] = useState([])

  const [expandedRepresentatives, setExpandedRepresentatives] = useState<Record<string, boolean>>(
    {}
  )

  const [datePickerRepresentativeBirthDate, setDatePickerRepresentativeBirthDate] = useState<
    Record<string, boolean>
  >({})
  const datePickerRepresentativeBirthDateRef = useRef<Record<string, HTMLDivElement | null>>({})
  const [datePickerBeneficialOwnerBirthDate, setDatePickerBeneficialOwnerBirthDate] = useState<
    Record<string, boolean>
  >({})
  const datePickerBeneficialOwnerBirthDateRef = useRef<Record<string, HTMLDivElement | null>>({})
  const [datePickerBeneficialLegalBirthDate, setDatePickerBeneficialLegalBirthDate] = useState<
    Record<string, boolean>
  >({})
  const datePickerBeneficialLegalBirthDateRef = useRef<Record<string, HTMLDivElement | null>>({})
  const [datePickerInstigationBirthDate, setDatePickerInstigationBirthDate] = useState<
    Record<string, boolean>
  >({})
  const datePickerInstigationBirthDateRef = useRef<Record<string, HTMLDivElement | null>>({})

  const [kycChecksNew, setKycChecksNew] = useState(false)
  const [kycChecks, setKycChecks] = useState([] as any[])
  const [pin, setPin] = useState('')
  const [access, setAccess] = useState(false)
  const [pinRequired, setPinRequired] = useState(true)

  const [options, setOptions] = useState([])
  const saveTimeoutRef = useRef<NodeJS.Timeout | null>(null)

  const [showModalIdentity, setShowModalIdentity] = useState(false)
  const [identitySubjectId, setIdentitySubjectId] = useState<string>('')
  const [identitySubjectType, setIdentitySubjectType] = useState<
    'client' | 'representative' | 'beneficialOwner'
  >('client')
  const [identityRequests, setIdentityRequests] = useState<Record<string, any>>({})
  const [variantIdentity, setVariantIdentity] = useState<
    Record<string, 'secondary' | 'success' | 'warning' | 'danger'>
  >({})
  const [surveyFiles, setSurveyFiles] = useState<Array<{ name: string }>>([])
  const [surveyUploading, setSurveyUploading] = useState(false)
  const surveyFileInputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (!clientId) return

    const fetchClientInfo = async () => {
      setLoading(true)
      setError(null)
      try {
        await fetchLegalForms()
        const response = await fetchClientById(clientId)
        setClient(response.client)

        const data = await getClientInfo(clientId)
        setClientInfo(data)

        if (data) {
          setFormData({
            id: data._id,
            dataCollected: data.dataCollected || false,
            newAssessment: data.newAssessment || false,
            name: data.name || '',
            legalForm: data.legalForm || '',
            registerType: data.registerType || '',
            registerNumber: data.registerNumber || '',
            gericht: data.gericht || '',
            address: data.address || '',
            extractFromCommerical: data.extractFromCommerical || false,
            foundingDocuments: data.foundingDocuments || false,
            ownDocumented: data.ownDocumented || false,
            otherDocuments: data.otherDocuments || false,
            idProof: data.idProof || false,
            electronicIdProof: data.electronicIdProof || false,
            otherProof: data.otherProof || false,
            shareHolder: data.shareHolder || '',
            shareHolderFoundations: data.shareHolderFoundations || '',
            beneficialOwners: {
              type: data.beneficialOwners?.type || null,
              legalEntities: data.beneficialOwners?.legalEntities || {},
              foundationsLegalCapacity: data.beneficialOwners?.foundationsLegalCapacity || {},
              instigationPersons: data.beneficialOwners?.instigationPersons || {},
              naturalPersonRoles: {
                admin: data.beneficialOwners?.naturalPersonRoles?.admin || false,
                management_board:
                  data.beneficialOwners?.naturalPersonRoles?.management_board || false,
                beneficiary: data.beneficialOwners?.naturalPersonRoles?.beneficiary || false,
                assets_distributed:
                  data.beneficialOwners?.naturalPersonRoles?.assets_distributed || false,
                other: data.beneficialOwners?.naturalPersonRoles?.other || false,
              },
            },
            noOneConnected: data.noOneConnected || false,
            closeToPolitically: data.closeToPolitically || false,
            preciseDesignation: data.preciseDesignation || '',
            notEstablishedInHighRiskCountry: data.notEstablishedInHighRiskCountry || false,
            establishedInHighRiskCountry: data.establishedInHighRiskCountry || false,
            thirdCountry: data.thirdCountry || '',
            purposeAndNatureClear: data.purposeAndNatureClear || false,
            purposeAndNatureDescription: data.purposeAndNatureDescription || false,
            purposeFurtherInfo: data.purposeFurtherInfo || '',
            furtherInfo: data.furtherInfo || '',
            noLegalEntityAdded: data.noLegalEntityAdded || false,
            beneficialOwnerSelection: data.beneficialOwnerSelection || '',
            isFinished: data.isFinished || false,
          })
        }
      } catch (err: any) {
        setError(err.message || 'Failed to fetch client info')
        console.error(err)
      } finally {
        setLoading(false)
      }
    }

    fetchClientInfo()
  }, [clientId])

  useEffect(() => {
    const pickers = [
      [datePickerRepresentativeBirthDateRef, setDatePickerRepresentativeBirthDate],
      [datePickerBeneficialOwnerBirthDateRef, setDatePickerBeneficialOwnerBirthDate],
      [datePickerBeneficialLegalBirthDateRef, setDatePickerBeneficialLegalBirthDate],
      [datePickerInstigationBirthDateRef, setDatePickerInstigationBirthDate],
    ] as const

    const handleClickOutside = (event: MouseEvent) => {
      pickers.forEach(([refs, setOpen]) => {
        Object.entries(refs.current).forEach(([key, el]) => {
          if (el && !el.contains(event.target as Node)) {
            setOpen(prev => (prev[key] ? { ...prev, [key]: false } : prev))
          }
        })
      })
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const fetchLegalForms = async () => {
    try {
      const options = await getLegalForms()
      setLegalForms(options)
    } catch (err) {
      console.error('Fetch legal forms error:', err)
    }
  }

  const autoSave = useCallback(
    async (data: typeof formData) => {
      if (!canEdit) return
      if (!clientInfo?._id) return

      try {
        await updateClientInfo(clientInfo._id, data)
      } catch (err: any) {
        console.error('Auto-save failed:', err)
      }
    },
    [clientInfo, canEdit]
  )

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!canEdit) return
    const { name, value, type, checked } = e.target

    // Check if this is a naturalPersonRoles field
    const naturalPersonRoleFields = [
      'admin',
      'management_board',
      'beneficiary',
      'assets_distributed',
      'other',
    ]

    let updatedData: any
    if (naturalPersonRoleFields.includes(name)) {
      updatedData = {
        ...formData,
        beneficialOwners: {
          ...formData.beneficialOwners,
          naturalPersonRoles: {
            ...formData.beneficialOwners.naturalPersonRoles,
            [name]: checked,
          },
        },
      }
    } else {
      updatedData = {
        ...formData,
        [name]: type === 'checkbox' ? checked : value,
      }
    }

    setFormData(updatedData)

    if (saveTimeoutRef.current) {
      clearTimeout(saveTimeoutRef.current)
    }
    saveTimeoutRef.current = setTimeout(() => {
      autoSave(updatedData)
    }, 600)
  }

  // Once the form is marked finished, build a downloadable PDF that lists every
  // question and its current answer as flowing text (jsPDF never splits a line
  // across a page, so nothing gets cut mid-sentence).
  const handleGeneratePdf = () => {
    setDatePickerRepresentativeBirthDate({})
    setDatePickerBeneficialOwnerBirthDate({})
    setDatePickerBeneficialLegalBirthDate({})

    setTimeout(() => {
      if (!surveyPdfRef.current) return
      downloadSurveyPdf(surveyPdfRef.current, {
        filename: `Erhebungsbogen_${client?.clientNumber ?? ''}`.replace(/\s+/g, '_'),
        heading: 'Erhebungsbogen',
        subheading: `${t('registerNumber')}: ${client?.clientNumber ?? '—'}${client?.name ? '  ·  ' + client.name : ''}`,
      }).catch(err => console.error('Survey PDF generation failed:', err))
    }, 100)
  }

  const handleTextAreaChanged = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (!canEdit) return
    const { name, value } = e.target

    const updatedData = {
      ...formData,
      [name]: value,
    }

    setFormData(updatedData)

    if (saveTimeoutRef.current) {
      clearTimeout(saveTimeoutRef.current)
    }

    saveTimeoutRef.current = setTimeout(() => {
      autoSave(updatedData)
    }, 600)
  }

  const handleSelectChanged = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (!canEdit) return
    const { name, value } = e.target

    const updatedData = {
      ...formData,
      [name]: value,
    }

    setFormData(updatedData)

    if (saveTimeoutRef.current) {
      clearTimeout(saveTimeoutRef.current)
    }

    saveTimeoutRef.current = setTimeout(() => {
      autoSave(updatedData)
    }, 1000)
  }

  useEffect(() => {
    fetchCountries()
    return () => {
      if (saveTimeoutRef.current) {
        clearTimeout(saveTimeoutRef.current)
      }
    }
  }, [])

  const handleAddRepresentative = async () => {
    if (!canEdit) return
    if (!clientInfo?._id) return

    try {
      const newRep: RepresentativeNaturalPerson = {
        relation: '',
        name: '',
        firstName: '',
        address: '',
        country: '',
        birthPlace: '',
        birthDate: '',
        nationality: '',
        idNumber: '',
        authority: '',
        notes: '',
        lastCheck: new Date().toString(),
        numberChecks: 0,
        risk: false,
        isActive: true,
        personContractingParty: false,
      }

      const result = await addRepresentative(clientInfo._id, newRep)

      if (!result) {
        showKAlert('danger', 'Failed to add representative')
        return
      }
      const updatedData = await getClientInfo(clientId!)
      setClientInfo(updatedData)
    } catch (err: any) {
      console.error('Error adding representative:', err)
      showKAlert('danger', 'Failed to add representative')
    }
  }

  const handleRepresentativeChange = (key: string, field: string, value: string | boolean) => {
    if (!canEdit) return
    if (!clientInfo?._id) return

    setClientInfo(prev => {
      if (!prev) return prev
      return {
        ...prev,
        contractualPartner: {
          ...prev.contractualPartner,
          representatives: {
            ...prev.contractualPartner.representatives,
            [key]: {
              ...prev.contractualPartner.representatives[key],
              [field]: value,
            },
          },
        },
      }
    })

    if (saveTimeoutRef.current) {
      clearTimeout(saveTimeoutRef.current)
    }

    saveTimeoutRef.current = setTimeout(async () => {
      try {
        await updateRepresentative(clientInfo._id!, key, { [field]: value })
      } catch (err: any) {
        console.error('Error updating representative:', err)
      }
    }, 500)
  }

  const handleDeleteRepresentative = async (key: string) => {
    if (!canEdit) return
    if (!clientInfo?._id) return
    if (!window.confirm('Are you sure you want to delete this representative?')) return

    try {
      await deleteRepresentative(clientInfo._id, key)

      const updatedData = await getClientInfo(clientId!)
      setClientInfo(updatedData)
    } catch (err: any) {
      console.error('Error deleting representative:', err)
      showKAlert('danger', 'Failed to delete representative')
    }
  }

  const handleAddRelatedCompany = async () => {
    if (!canEdit) return
    if (!clientInfo?._id) return

    try {
      const newCompany: RelatedCompany = {
        relation: '',
        name: '',
        registerNumber: '',
        address: '',
        land: '',
        lastCheck: new Date().toString(),
        numberChecks: 0,
        risk: false,
        isActive: true,
        personContractingParty: false,
        legalForm: '',
      }

      const result = await addRelatedCompany(clientInfo._id, newCompany)

      if (!result) {
        showKAlert('danger', 'Failed to add company')
        return
      }

      // Refresh client info to show new company
      const updatedData = await getClientInfo(clientId!)
      setClientInfo(updatedData)
    } catch (err: any) {
      console.error('Error adding related company:', err)
      alert('Failed to add related company')
    }
  }

  const handleCompanyChange = (key: string, field: string, value: string | boolean) => {
    if (!canEdit) return
    if (!clientInfo?._id) return

    setClientInfo(prev => {
      if (!prev) return prev
      return {
        ...prev,
        contractualPartner: {
          ...prev.contractualPartner,
          relatedCompanies: {
            ...prev.contractualPartner.relatedCompanies,
            [key]: {
              ...prev.contractualPartner.relatedCompanies[key],
              [field]: value,
            },
          },
        },
      }
    })

    if (saveTimeoutRef.current) {
      clearTimeout(saveTimeoutRef.current)
    }

    saveTimeoutRef.current = setTimeout(async () => {
      try {
        await updateRelatedCompany(clientInfo._id!, key, { [field]: value })
      } catch (err: any) {
        console.error('Error updating related company:', err)
      }
    }, 500)
  }

  const toggleRepresentativeExpansion = (key: string) => {
    setExpandedRepresentatives(prev => ({
      ...prev,
      [key]: !prev[key],
    }))
  }

  const handleDeleteCompany = async (key: string) => {
    if (!canEdit) return
    if (!clientInfo?._id) return
    if (!window.confirm('Are you sure you want to delete this company?')) return

    try {
      await deleteRelatedCompany(clientInfo._id, key)

      const updatedData = await getClientInfo(clientId!)
      setClientInfo(updatedData)
    } catch (err: any) {
      console.error('Error deleting company: ', err)
    }
  }

  const handleAddBeneficialOwner = async (type: string) => {
    if (!canEdit) return
    if (!clientInfo?._id) return

    try {
      // Map frontend type to backend type
      const backendType =
        type === 'legalEntities'
          ? 'legalEntities'
          : type === 'foundations'
            ? 'foundationsLegalCapacity'
            : type === 'instigationPersons'
              ? 'instigationPersons'
              : 'legalEntities'

      const newOwner: BeneficialOwner = {
        type: backendType,
        isPerson: true,
        name: '',
        firstName: '',
        country: '',
        birthDate: '',
        nationality: '',
        idNumber: '',
        authority: '',
        identityVerificationThrough: '',
        notes: '',
        lastCheck: new Date().toString(),
        numberChecks: 0,
        risk: false,
      }

      const result = await addBeneficialOwner(clientInfo._id, newOwner)

      if (!result) {
        showKAlert('danger', 'Failed to add beneficial owner')
        return
      }

      const updatedData = await getClientInfo(clientId!)
      setClientInfo(updatedData)
    } catch (err: any) {
      console.error('Error adding beneficial owner:', err)
      alert('Failed to add beneficial owner')
    }
  }

  const handleBeneficialOwnerChange = (
    type: string,
    key: string,
    field: string,
    value: string | boolean
  ) => {
    if (!canEdit) return
    if (!clientInfo?._id) return
    const beneficialOwnersType:
      'legalEntities' | 'foundationsLegalCapacity' | 'instigationPersons' =
      type === 'legalEntities'
        ? 'legalEntities'
        : type === 'foundations'
          ? 'foundationsLegalCapacity'
          : type === 'instigationPersons'
            ? 'instigationPersons'
            : 'legalEntities'

    setClientInfo(prev => {
      if (!prev) return prev

      const currentOwners = prev.beneficialOwners[beneficialOwnersType] || {}
      const currentOwner = currentOwners[key] || {}

      return {
        ...prev,
        beneficialOwners: {
          ...prev.beneficialOwners,
          [beneficialOwnersType]: {
            ...currentOwners,
            [key]: {
              ...currentOwner,
              [field]: value,
            },
          },
        },
      }
    })

    if (saveTimeoutRef.current) {
      clearTimeout(saveTimeoutRef.current)
    }

    saveTimeoutRef.current = setTimeout(async () => {
      try {
        await updateBeneficialOwner(clientInfo._id!, key, {
          [field]: value,
          type: beneficialOwnersType,
        })
      } catch (err: any) {
        console.error('Error updating beneficial owner:', err)
      }
    }, 1000)
  }

  const handleDeleteBeneficialOwner = async (key: string, type: string) => {
    if (!canEdit) return
    if (!clientInfo?._id) return
    if (!window.confirm('Are you sure you want to delete this beneficial owner?')) return

    try {
      // Map frontend type to backend type
      const backendType =
        type === 'legalEntities'
          ? 'legalEntities'
          : type === 'foundations'
            ? 'foundationsLegalCapacity'
            : type === 'instigationPersons'
              ? 'instigationPersons'
              : 'legalEntities'

      await deleteBeneficialOwner(clientInfo._id, key, backendType)

      const updatedData = await getClientInfo(clientId!)
      setClientInfo(updatedData)
    } catch (err: any) {
      console.error('Error deleting beneficial owner:', err)
      showKAlert('danger', 'Failed to delete beneficial owner')
    }
  }

  const getAccess = async () => {
    const result = await fetchAccess(localStorage.getItem('email'))

    if (!!result.accessToken) {
      setAccessToken(result.accessToken)
      setPin(result.pinCode)
      setPinRequired(result.pinRequired !== false)
      setAccess(true)
    }
  }

  const checkPin = async (pinCode: number) => {
    try {
      const result = await validatePinCode(pinCode)

      if (result?.userAccess) {
        setUserAccess(result.userAccess)
        setAccess(false)

        const response = await kycCheck()
        if (response) {
          setKycChecksNew(true)
        }
      }
    } catch (error) {
      console.error('Error validating pin code:', error)
    }
  }

  const kycCheck = async () => {
    try {
      setLoading(true)
      setError(null)

      const result = await performKycCheckOne({
        clientRepresentId: localStorage.getItem('representativeKey') ?? '',
        clientId: localStorage.getItem('clientId'),
        clientNumber: localStorage.getItem('clientNumber'),
        firstName: localStorage.getItem('firstName'),
        lastName: localStorage.getItem('name'),
        dateOfBirth: localStorage.getItem('dateOfBirth'),
        country: localStorage.getItem('country'),
        accessToken: getAccessToken() ?? '',
        companyInfo: getCompanyInfo(),
        clientInfo: true,
        clientInfoId: localStorage.getItem('clientInfoId') ?? '',
      })

      if (!result || result.length === 0) {
        showKAlert('warning', 'No results returned from KYC check')
        return null
      }

      clearKycCheckCache(formData.id)
      setKycChecks(result[0])
      setKycChecksNew(true)
      showKAlert('success', 'KYC check completed successfully')
      return result
    } catch (error: any) {
      console.error('Error performing KYC check:', error)
      showKAlert('danger', error.message || 'Failed to perform KYC check')
      setError(error.message || 'Failed to perform KYC check')
      return null
    } finally {
      setLoading(false)
    }
  }

  const getKycCheck = async (representativeKey: string) => {
    try {
      setLoading(true)
      setError(null)

      const response = await getKycCheckClientInfo(representativeKey)

      if (!response.ok) {
        throw new Error(response.message?.content || 'Failed to fetch KYC check data')
      }

      if (!response.result) {
        showKAlert('warning', 'No KYC check data found')
        return
      }

      setKycChecks(response.result)
      setKycChecksNew(true)
    } catch (error: any) {
      console.error('Error fetching KYC check:', error)
      showKAlert('danger', error.message || 'Failed to load KYC check data')
      setError(error.message || 'Failed to load KYC check data')
    } finally {
      setLoading(false)
    }
  }

  const fetchCountries = async () => {
    try {
      const response = await getCountries()
      setOptions(response.countries.map((c: any) => ({ value: c.code, label: c.name })))
    } catch (err) {
      console.error('Fetch countries: ', err)
    }
  }

  const createIdentityRequest = async () => {
    if (!canEdit) return
    const userAccess = sessionStorage.getItem('userAccess') ?? ''
    const userAccessParsed = JSON.parse(userAccess)

    try {
      const result = await createIdentityRequestService({
        service: 'identity',
        identityData: {
          gender: localStorage.getItem('gender'),
          firstName: localStorage.getItem('firstName'),
          name: localStorage.getItem('name'),
          dateOfBirth: '',
          email: localStorage.getItem('email'),
          createdAt: new Date(),
          status: 'assigned',
          clientId: localStorage.getItem('clientId'),
          subjectId: identitySubjectId,
          subjectType: identitySubjectType,
          companyId: sessionStorage.getItem('companyInfo'),
          requestEmail: userAccessParsed['email'],
        },
      })

      if (result?.error === 'no_credit') {
        showKAlert('danger', 'notEnoughCredit')
        setShowModalIdentity(false)
        return
      }

      if (result?.success && identitySubjectId) {
        setVariantIdentity(prev => ({
          ...prev,
          [identitySubjectId]: 'warning',
        }))
        await fetchIdentityStatusForSubject(identitySubjectId)
      }

      setShowModalIdentity(false)
    } catch (err) {
      showKAlert('danger', 'An unexpected error occurred. Please try again.')
    }
  }

  const fetchIdentityStatusForSubject = async (subjectId: string) => {
    try {
      const res = await fetchIdentityParams(clientId || null, subjectId)

      setIdentityRequests(prev => {
        if (!res?.identity) {
          const { [subjectId]: _, ...rest } = prev
          return rest
        }

        return {
          ...prev,
          [subjectId]: res.identity,
        }
      })

      setVariantIdentity(prev => ({
        ...prev,
        [subjectId]: res?.ok && res?.identity ? 'success' : res?.identity ? 'warning' : 'secondary',
      }))
    } catch (e) {
      setVariantIdentity(prev => ({
        ...prev,
        [subjectId]: 'secondary',
      }))

      setIdentityRequests(prev => {
        const { [subjectId]: _, ...rest } = prev
        return rest
      })
    }
  }

  useEffect(() => {
    if (!clientId) return

    const subjectIds = [
      ...Object.keys(representatives),
      ...Object.keys(relatedCompanies),
      ...Object.keys(beneficialOwnersLegalEntities),
      ...Object.keys(beneficialOwnersFoundations),
      ...Object.keys(beneficialOwnersInstigationPersons),
    ]

    if (!subjectIds.length) return

    let cancelled = false

    const preloadIdentityStatuses = async () => {
      const results = await Promise.all(
        subjectIds.map(async subjectId => {
          try {
            const res = await fetchIdentityParams(clientId, subjectId)
            const variant: 'secondary' | 'success' | 'warning' | 'danger' =
              res?.ok && res?.identity ? 'success' : res?.identity ? 'warning' : 'secondary'

            return { subjectId, variant, identity: res?.identity || null }
          } catch {
            return { subjectId, variant: 'secondary' as const, identity: null }
          }
        })
      )

      if (cancelled) return

      setVariantIdentity(prev => {
        const next = { ...prev }
        results.forEach(({ subjectId, variant }) => {
          next[subjectId] = variant
        })
        return next
      })

      setIdentityRequests(prev => {
        const next = { ...prev }
        results.forEach(({ subjectId, identity }) => {
          if (identity) {
            next[subjectId] = identity
          } else {
            delete next[subjectId]
          }
        })
        return next
      })
    }

    preloadIdentityStatuses()

    return () => {
      cancelled = true
    }
  }, [
    clientId,
    representatives,
    relatedCompanies,
    beneficialOwnersLegalEntities,
    beneficialOwnersFoundations,
    beneficialOwnersInstigationPersons,
  ])

  const openIdentityModal = async (
    subjectId: string,
    subjectType: 'client' | 'representative' | 'beneficialOwner'
  ) => {
    if (isPiiEncryptionEnabled()) {
      showKAlert('danger', t('serviceDisabledByPiiEncryption'))
      return
    }
    setIdentitySubjectId(subjectId)
    setIdentitySubjectType(subjectType)
    await fetchIdentityStatusForSubject(subjectId)
    setShowModalIdentity(true)
  }

  const removeIdentityRequest = async () => {
    if (!canEdit) return
    const subjectId = identitySubjectId
    const identity = identityRequests[subjectId]

    if (!identity) return

    const confirmed = window.confirm('Are you sure you want to remove the DS|Identity request?')
    if (!confirmed) return

    try {
      const result = await deleteIdentityRequestService({
        identityCompanyId: identity.identityCompanyId,
        identityRequestId: identity.identityRequestId,
        clientId: identity.clientId,
        subjectId: identity.subjectId || subjectId,
      })

      if (result?.success) {
        setVariantIdentity(prev => ({
          ...prev,
          [subjectId]: 'secondary',
        }))

        setIdentityRequests(prev => {
          const { [subjectId]: _, ...rest } = prev
          return rest
        })

        showKAlert('success', 'DS|Identity request removed.')
        setShowModalIdentity(false)
      } else {
        showKAlert('danger', 'Failed to remove DS|Identity request.')
      }
    } catch (error) {
      showKAlert('danger', 'Failed to remove DS|Identity request.')
    }
  }

  const fetchSurveyFiles = async (firmename: string) => {
    if (!clientId || !firmename) return
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/files/kyc/documents`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ clientId, firmename }),
      })
      const data = await res.json()
      setSurveyFiles((data.documents || []).filter((f: any) => f.type === 'survey_form'))
    } catch {}
  }

  const handleSurveyUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!canEdit) return
    const file = e.target.files?.[0]
    if (!file || !clientId || !client?.name) return
    const fd = new FormData()
    fd.append('clientId', clientId)
    fd.append('firmename', client.name)
    fd.append('type', 'survey_form')
    fd.append('file', file)
    setSurveyUploading(true)
    try {
      await fetch(`${process.env.REACT_APP_API_URL}/files/kyc/upload`, { method: 'POST', body: fd })
      await fetchSurveyFiles(client.name)
    } finally {
      setSurveyUploading(false)
      if (surveyFileInputRef.current) surveyFileInputRef.current.value = ''
    }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (client?.name) fetchSurveyFiles(client.name)
  }, [client?.name, clientId])

  if (loading) {
    return (
      <Container>
        <div className='text-center mt-5'>Loading...</div>
      </Container>
    )
  }

  if (error) {
    return (
      <Container>
        <div className='alert alert-danger mt-5'>{error}</div>
      </Container>
    )
  }

  return (
    <>
      <Container>
        <Row>
          <div className='sidebar col-md-3 col-lg-2 p-0'>
            <KLayerNavigation logged={isUserLoggedIn()} />
          </div>
          <main
            className='col-md-14 col-lg-10'
            style={{ maxHeight: '100vh', overflowY: 'auto', paddingBottom: '20rem' }}
          >
            <fieldset
              ref={surveyPdfRef}
              disabled={!canEdit}
              className='border-0 p-0 m-0 survey-pdf'
              style={{ minWidth: 0 }}
            >
              {!canEdit && <div className='alert alert-info mt-3'>{t('readOnlyNoPermission')}</div>}
              <Row>
                <Col className='col-sm-9'>
                  <Card.Title>
                    <h5 className='text-draft'>{t(getDataSecurityCompanyName())}</h5>
                    <h4 className='fw-bold'>{t('surveyForm')}</h4>
                  </Card.Title>
                  <hr />
                  <div className='mb-4'>
                    <b className=''>
                      {t('registerNumber')}: {client?.clientNumber}
                    </b>
                  </div>
                  {/* A 1 */}
                  <h5 className='fw-bold'>A. {t('contractualPartner')}</h5>
                  <div className='ms-4'>
                    <h6 className='fw-bold'>1. {t('identification')}</h6>
                    {/* a) */}
                    <div className='ms-4'>
                      <h5 className='fw-bold'>a) {t('establishingIdentity')}</h5>

                      {/* Already Identified Checkbox */}
                      <div className='ms-4 mt-2'>
                        <input
                          id='dataCollected'
                          className='form-check-input'
                          type='checkbox'
                          name='dataCollected'
                          checked={formData.dataCollected}
                          onChange={handleInputChange}
                        />
                        <label className='form-check-label' htmlFor='dataCollected'>
                          &nbsp;{t('alreadyIdentified')}
                        </label>
                      </div>

                      {/* New Assessment Checkbox */}
                      <div className='ms-4 mt-2'>
                        <input
                          id='newAssessment'
                          className='form-check-input'
                          type='checkbox'
                          name='newAssessment'
                          checked={formData.newAssessment}
                          onChange={handleInputChange}
                        />
                        <label className='form-check-label' htmlFor='newAssessment'>
                          &nbsp;{t('newAssessment')}
                        </label>
                      </div>

                      {/* Company Name */}
                      <div className='mt-2'>
                        <label htmlFor='name'>{t('companyName')}</label>
                        <input
                          id='name'
                          className='form-control bg-info2'
                          type='text'
                          name='name'
                          value={formData.name}
                          onChange={handleInputChange}
                        />
                      </div>

                      {/* Legal Form */}
                      <div className='mt-2'>
                        <label htmlFor='legalForm'>{t('legalForm')}</label>

                        <select
                          id='legalForm'
                          className='form-control bg-info2'
                          name='legalForm'
                          value={formData.legalForm}
                          onChange={handleSelectChanged}
                        >
                          <option value=''>{'-- '}</option>
                          {legalForms.map((opt: any, idx) => (
                            <option key={idx} value={opt.value}>
                              {opt.label}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className='mt-2'>
                        <label htmlFor='registerType'>{t('Registertyp')}</label>
                        <select
                          id='registerType'
                          className='form-control bg-info2'
                          name='registerType'
                          value={formData.registerType}
                          onChange={handleSelectChanged}
                        >
                          <option value=''>{'-- '}</option>
                          {['GnR', 'HRA', 'HRB', 'PR', 'VR', 'GsR'].map(opt => (
                            <option key={opt} value={opt}>
                              {opt}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* Register Number */}
                      <div className='mt-2'>
                        <label htmlFor='registerNumber'>{t('registerNumber')}</label>
                        <input
                          id='registerNumber'
                          className='form-control bg-info2'
                          type='text'
                          name='registerNumber'
                          value={formData.registerNumber}
                          onChange={handleInputChange}
                        />
                      </div>

                      <div className='mt-2'>
                        <label htmlFor='gericht'>{t('Court')}</label>
                        <input
                          id='gericht'
                          className='form-control bg-info2'
                          type='text'
                          name='gericht'
                          value={formData.gericht}
                          onChange={handleInputChange}
                        />
                      </div>

                      {/* Address */}
                      <div className='mt-2'>
                        <label htmlFor='address' style={{ textTransform: 'none' }}>
                          {t('addressOfRegisteredOffice')}
                        </label>
                        <input
                          id='address'
                          className='form-control bg-info2'
                          type='text'
                          name='address'
                          value={formData.address}
                          onChange={handleInputChange}
                        />
                      </div>

                      <h6 className='mt-4 fw-bold'>{t('representativeBody')}</h6>
                      <div>
                        {!hasRepresentatives ? (
                          <Button
                            className='btn btn-warning2 mt-2'
                            size='sm'
                            onClick={handleAddRepresentative}
                          >
                            + {t('VNPhinzufügen')}
                          </Button>
                        ) : (
                          <>
                            {Object.entries(
                              representatives as Record<string, RepresentativeNaturalPerson>
                            ).map(([key, rep]) => (
                              <div key={key} className='mb-4'>
                                <div className='d-flex justify-content-between mb-2'>
                                  <div className='mt-4'>
                                    <b>
                                      VNP-
                                      <span>{key.replace('representative-', '')}</span>
                                    </b>
                                    &nbsp;{t('representativeNaturalPerson')}
                                  </div>
                                  <KButton
                                    icon='trash'
                                    variant='danger'
                                    size='sm'
                                    onClick={() => handleDeleteRepresentative(key)}
                                  />
                                </div>
                                <Row>
                                  <Col md={12}>
                                    <div className='mb-2'>
                                      <select
                                        id='relation'
                                        className='form-control mt-2 bg-info2'
                                        value={rep.relation}
                                        onChange={e =>
                                          handleRepresentativeChange(
                                            key,
                                            'relation',
                                            e.target.value
                                          )
                                        }
                                      >
                                        <option value='Beziehung'>{t('Beziehung')}</option>
                                        <option value='Gesetzlicher Vertreter des Unternehmens'>
                                          {t('Gesetzlicher Vertreter des Unternehmens')}
                                        </option>
                                        <option value='Vertretungsbevollmächtigter'>
                                          {t('Vertretungsbevollmächtigter')}
                                        </option>
                                        <option value='Mitwirkungsbevollmächtigter'>
                                          {t('Mitwirkungsbevollmächtigter')}
                                        </option>
                                        <option value='Empfangsbevollmächtigter'>
                                          {t('Empfangsbevollmächtigter')}
                                        </option>
                                        <option value='Partei kraft Amtes'>
                                          {t('Partei kraft Amtes')}
                                        </option>
                                      </select>
                                    </div>
                                  </Col>
                                  <Col md={12}>
                                    <div className='mb-2'>
                                      <input
                                        placeholder={t('nameBeneficial')}
                                        className='form-control form-control-sm bg-info2'
                                        type='text'
                                        value={rep.name}
                                        onChange={e =>
                                          handleRepresentativeChange(key, 'name', e.target.value)
                                        }
                                      />
                                    </div>
                                  </Col>
                                  <Col md={12}>
                                    <div className='mb-2'>
                                      <input
                                        placeholder={t('firstName')}
                                        className='form-control form-control-sm bg-info2'
                                        type='text'
                                        value={rep.firstName}
                                        onChange={e =>
                                          handleRepresentativeChange(
                                            key,
                                            'firstName',
                                            e.target.value
                                          )
                                        }
                                      />
                                    </div>
                                  </Col>
                                  <Col md={12}>
                                    <div className='mb-2'>
                                      <input
                                        placeholder={t('address')}
                                        className='form-control form-control-sm bg-info2'
                                        type='text'
                                        value={rep.address}
                                        onChange={e =>
                                          handleRepresentativeChange(key, 'address', e.target.value)
                                        }
                                      />
                                    </div>
                                  </Col>
                                  <Col md={6}>
                                    <div className='mb-2'>
                                      <Form.Select
                                        className='bg-info2 form-select-sm'
                                        id='country'
                                        value={rep.country}
                                        onChange={e =>
                                          handleRepresentativeChange(key, 'country', e.target.value)
                                        }
                                      >
                                        <option label={t('--')}></option>
                                        {options.map((option: any) => (
                                          <option key={option.value} value={option.value}>
                                            {t(option.label)}
                                          </option>
                                        ))}
                                      </Form.Select>
                                    </div>
                                  </Col>
                                  <Col md={12}>
                                    <div className='mb-2'>
                                      <input
                                        placeholder={t('birthPlace')}
                                        className='form-control form-control-sm bg-info2'
                                        type='text'
                                        value={rep.birthPlace}
                                        onChange={e =>
                                          handleRepresentativeChange(
                                            key,
                                            'birthPlace',
                                            e.target.value
                                          )
                                        }
                                      />
                                    </div>
                                  </Col>
                                  <Col md={6}>
                                    <div
                                      className='mb-2'
                                      ref={(el: any) =>
                                        (datePickerRepresentativeBirthDateRef.current[key] = el)
                                      }
                                      style={{ position: 'relative' }}
                                    >
                                      <Form.Control
                                        size='sm'
                                        className='bg-info2'
                                        placeholder={t('dateOfBirth')}
                                        type='text'
                                        value={rep.birthDate || ''}
                                        onChange={e =>
                                          handleRepresentativeChange(
                                            key,
                                            'birthDate',
                                            sanitizeDDMMYYYYInput(e.target.value)
                                          )
                                        }
                                        onClick={() =>
                                          setDatePickerRepresentativeBirthDate(prev => ({
                                            ...prev,
                                            [key]: true,
                                          }))
                                        }
                                      />

                                      <KDayPicker
                                        open={!!datePickerRepresentativeBirthDate[key]}
                                        value={rep.birthDate}
                                        onSelect={date => {
                                          const formatted = formatDDMMYYYY(date)
                                          handleRepresentativeChange(key, 'birthDate', formatted)
                                          setDatePickerRepresentativeBirthDate(prev => ({
                                            ...prev,
                                            [key]: false,
                                          }))
                                        }}
                                      />
                                    </div>
                                  </Col>
                                  <Col md={12}>
                                    <div className='mb-2'>
                                      <input
                                        placeholder={t('nationality')}
                                        className='form-control form-control-sm bg-info2'
                                        type='text'
                                        value={rep.nationality}
                                        onChange={e =>
                                          handleRepresentativeChange(
                                            key,
                                            'nationality',
                                            e.target.value
                                          )
                                        }
                                      />
                                    </div>
                                  </Col>
                                  <Col md={12}>
                                    <div className='mb-2'>
                                      <input
                                        placeholder={t('idNumber')}
                                        className='form-control form-control-sm bg-info2'
                                        type='text'
                                        value={rep.idNumber}
                                        onChange={e =>
                                          handleRepresentativeChange(
                                            key,
                                            'idNumber',
                                            e.target.value
                                          )
                                        }
                                      />
                                    </div>
                                  </Col>
                                  <Col md={12}>
                                    <div className='mb-2'>
                                      <input
                                        placeholder={t('authority')}
                                        className='form-control form-control-sm bg-info2'
                                        type='text'
                                        value={rep.authority}
                                        onChange={e =>
                                          handleRepresentativeChange(
                                            key,
                                            'authority',
                                            e.target.value
                                          )
                                        }
                                      />
                                    </div>
                                  </Col>
                                  <Col>
                                    <KButton
                                      className='btn-user-primary btn-sm bg-collapse'
                                      icon='justify'
                                      title={t('notes')}
                                      onClick={() => {
                                        setShowModal(true)
                                      }}
                                    />
                                    <KButton
                                      className='btn-user-primary btn-sm btn-spacing bg-collapse'
                                      icon='eye'
                                      title={t('view')}
                                      onClick={() => {
                                        getKycCheck(key)
                                      }}
                                    />
                                    <KButton
                                      id='shufaCheck'
                                      variant={getKycCheckVariant(rep.lastCheck, rep.risk)}
                                      type='button'
                                      icon='check'
                                      className='text-white btn-spacing'
                                      title={t('ds | kyc check')}
                                      onClick={() => {
                                        localStorage.setItem('representativeKey', key)
                                        localStorage.setItem('clientInfoId', formData.id)
                                        localStorage.setItem('clientId', clientId || '')
                                        localStorage.setItem('name', rep.name)
                                        localStorage.setItem('firstName', rep.firstName)
                                        localStorage.setItem('country', rep.country)
                                        localStorage.setItem('dateOfBirth', rep.birthDate ?? '')
                                        getAccess()
                                      }}
                                    ></KButton>
                                    <KButton
                                      variant={variantIdentity[key] || 'secondary'}
                                      className='text-white btn-spacing'
                                      icon='person-bounding-box'
                                      title={t('DS | Identity')}
                                      onClick={() => {
                                        localStorage.setItem('name', rep.name)
                                        localStorage.setItem('firstName', rep.firstName)
                                        localStorage.setItem('country', rep.country)
                                        localStorage.setItem('clientId', clientId || '')
                                        openIdentityModal(key, 'representative')
                                      }}
                                    />
                                    <KButton
                                      className='btn-user-primary btn-sm btn-spacing bg-collapse'
                                      icon='folder2-open'
                                      title={t('documents')}
                                      onClick={() => {
                                        navigate(
                                          `/client/identity-documents/${clientId}/representative/${key}`
                                        )
                                      }}
                                    />
                                  </Col>
                                  <Modal
                                    id='noticeModal'
                                    type={''}
                                    show={showModal}
                                    onHide={() => setShowModal(false)}
                                  >
                                    <Modal.Header closeButton className='bg-secondary'>
                                      <Modal.Title>{t('notice')}</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                      <textarea
                                        className='notice mt-3 bg-info2 w-100'
                                        placeholder={t('notice')}
                                        value={rep.notes}
                                        onChange={e =>
                                          handleRepresentativeChange(key, 'notes', e.target.value)
                                        }
                                      />
                                    </Modal.Body>
                                    <Modal.Footer>
                                      <Button
                                        variant='secondary'
                                        onClick={() => setShowModal(false)}
                                      >
                                        {t('close') || 'Close'}
                                      </Button>
                                    </Modal.Footer>
                                  </Modal>
                                </Row>
                              </div>
                            ))}

                            <Button
                              className='btn btn-warning2 mt-2'
                              size='sm'
                              onClick={handleAddRepresentative}
                            >
                              + {t('VNPhinzufügen')}
                            </Button>
                          </>
                        )}
                      </div>

                      {/* RELATED COMPANIES */}
                      <h6 className='mt-4 fw-bold'>{t('relatedCompanyBody')}</h6>
                      <div className='mb-2 form-check'>
                        <input
                          id='noLegalEntityAdded'
                          className='form-check-input'
                          type='checkbox'
                          name='noLegalEntityAdded'
                          checked={!hasRelatedCompanies || formData.noLegalEntityAdded}
                          onChange={handleInputChange}
                        />
                        <label className='form-check-label' htmlFor='noLegalEntityAdded'>
                          {t('noLegalEntityAdded')}
                        </label>
                      </div>
                      <div>
                        {!hasRelatedCompanies ? (
                          <Button
                            className='btn btn-warning2 mt-2'
                            size='sm'
                            onClick={handleAddRelatedCompany}
                          >
                            + {t('VNPhinzufügen')}
                          </Button>
                        ) : (
                          // Has companies - show list
                          <>
                            {/* {Object.entries(representatives as Record<string, RepresentativeNaturalPerson>).map(([key, rep]) => ( */}
                            {Object.entries(relatedCompanies as Record<string, RelatedCompany>).map(
                              ([key, company]) => (
                                <div key={key} className='mb-4'>
                                  <div className='d-flex justify-content-between mb-2'>
                                    <div className='mt-4'>
                                      <b>
                                        VJP-
                                        <span>{key.replace('related-company-', '')}</span>
                                      </b>
                                      &nbsp;{t('representativeLegalEntity')}
                                    </div>

                                    <KButton
                                      icon='trash'
                                      variant='danger'
                                      size='sm'
                                      onClick={() => handleDeleteCompany(key)}
                                    />
                                  </div>

                                  <Row>
                                    <Col md={12}>
                                      <div className='mb-2'>
                                        <select
                                          id='relation'
                                          value={company.relation}
                                          className='form-control mt-2 bg-info2'
                                          onChange={e =>
                                            handleCompanyChange(key, 'relation', e.target.value)
                                          }
                                        >
                                          <option value='Beziehung'>{t('Beziehung')}</option>
                                          <option value='Gesetzlicher Vertreter des Unternehmens'>
                                            {t('Gesetzlicher Vertreter des Unternehmens')}
                                          </option>
                                          <option value='Vertretungsbevollmächtigter'>
                                            {t('Vertretungsbevollmächtigter')}
                                          </option>
                                          <option value='Mitwirkungsbevollmächtigter'>
                                            {t('Mitwirkungsbevollmächtigter')}
                                          </option>
                                          <option value='Empfangsbevollmächtigter'>
                                            {t('Empfangsbevollmächtigter')}
                                          </option>
                                          <option value='Partei kraft Amtes'>
                                            {t('Partei kraft Amtes')}
                                          </option>
                                        </select>
                                      </div>
                                    </Col>
                                    <Col md={12}>
                                      <div className='mb-2'>
                                        <input
                                          placeholder={t('nameBeneficial')}
                                          id='companyName'
                                          className='form-control bg-info2'
                                          type='text'
                                          name='companyName'
                                          value={company.name}
                                          onChange={e =>
                                            handleCompanyChange(key, 'name', e.target.value)
                                          }
                                        />
                                      </div>
                                    </Col>
                                    <Col md={12}>
                                      <div className='mb-2'>
                                        <select
                                          id='legalForm'
                                          className='form-control'
                                          name='legalForm'
                                          value={company.legalForm}
                                          onChange={handleSelectChanged}
                                        >
                                          <option value=''>{'-- '}</option>
                                          {legalForms.map((opt: any, idx) => (
                                            <option key={idx} value={opt.value}>
                                              {opt.label}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                    </Col>
                                    <Col md={12}>
                                      <div className='mb-2'>
                                        <input
                                          placeholder={t('registerNumber')}
                                          id='companyRegisterNumber'
                                          className='form-control form-control-sm bg-info2'
                                          type='text'
                                          value={company.registerNumber}
                                          onChange={e =>
                                            handleCompanyChange(
                                              key,
                                              'registerNumber',
                                              e.target.value
                                            )
                                          }
                                        />
                                      </div>
                                    </Col>
                                    <Col md={12}>
                                      <div className='mb-2'>
                                        <input
                                          placeholder={t('addressOfRegisteredOffice')}
                                          className='form-control form-control-sm bg-info2'
                                          type='text'
                                          value={company.address}
                                          onChange={e =>
                                            handleCompanyChange(key, 'address', e.target.value)
                                          }
                                        />
                                      </div>
                                    </Col>
                                    <Col md={12}>
                                      <div className='mb-2'>
                                        <Form.Select
                                          id='companyLand'
                                          className='bg-info2 form-select-sm'
                                          value={company.land}
                                          onChange={e =>
                                            handleCompanyChange(key, 'land', e.target.value)
                                          }
                                        >
                                          <option
                                            label={t('chooseCountry')}
                                            style={{ textTransform: 'none' }}
                                          ></option>
                                          {options.map((option: any) => (
                                            <option key={option.value} value={option.value}>
                                              {t(option.label)}
                                            </option>
                                          ))}
                                        </Form.Select>
                                      </div>
                                    </Col>
                                  </Row>
                                </div>
                              )
                            )}

                            <Button
                              className='btn btn-warning2 mt-2'
                              size='sm'
                              onClick={handleAddRelatedCompany}
                            >
                              + {t('VNPhinzufügen')}
                            </Button>
                          </>
                        )}
                      </div>
                    </div>
                    {/* b) */}
                    <div className='ms-4 mt-4' style={{ position: 'relative', zIndex: 1 }}>
                      <h5 className='fw-bold'>b) {t('identitVerificationContractualPartner')}</h5>
                      <h5 className='mt-3 fw-bold'>{t('identityHasBeenVerified')}</h5>
                      <div className='form-check mt-2'>
                        <input
                          id='extractFromCommerical'
                          className='form-check-input'
                          type='checkbox'
                          name='extractFromCommerical'
                          checked={formData.extractFromCommerical}
                          onChange={handleInputChange}
                        />
                        <label
                          className='form-check-label'
                          htmlFor='extractFromCommerical'
                          style={{ cursor: 'pointer' }}
                        >
                          &nbsp;{t('extractFromCommerical')}
                        </label>
                      </div>
                      <div className='form-check mt-2'>
                        <input
                          id='foundingDocuments'
                          className='form-check-input'
                          type='checkbox'
                          name='foundingDocuments'
                          checked={formData.foundingDocuments}
                          onChange={handleInputChange}
                        />
                        <label
                          className='form-check-label'
                          htmlFor='foundingDocuments'
                          style={{ cursor: 'pointer' }}
                        >
                          &nbsp;{t('foundingDocuments')}
                        </label>
                      </div>
                      <div className='form-check mt-2'>
                        <input
                          id='ownDocumented'
                          className='form-check-input'
                          type='checkbox'
                          name='ownDocumented'
                          checked={formData.ownDocumented}
                          onChange={handleInputChange}
                        />
                        <label
                          className='form-check-label'
                          htmlFor='ownDocumented'
                          style={{ cursor: 'pointer' }}
                        >
                          &nbsp;{t('ownDocumented')}
                        </label>
                      </div>
                      <div className='form-check mt-2'>
                        <input
                          id='otherDocuments'
                          className='form-check-input'
                          type='checkbox'
                          name='otherDocuments'
                          checked={formData.otherDocuments}
                          onChange={handleInputChange}
                        />
                        <label
                          className='form-check-label'
                          htmlFor='otherDocuments'
                          style={{ cursor: 'pointer' }}
                        >
                          &nbsp;{t('simplifiedDueDiligence')}
                        </label>
                      </div>
                    </div>
                    {/* A2 */}
                    <h5 className='mt-4 fw-bold'>2. {t('personActingContractualPartner')}</h5>
                    {/* a) */}
                    <div className='ms-4'>
                      <h5 className='fw-bold'>a) {t('identificationContractualPartner')}</h5>
                      {Object.entries(
                        representatives as Record<string, RepresentativeNaturalPerson>
                      ).map(([key, rep]) => (
                        <div key={key} className='py-2 ps-4'>
                          <div className='form-check'>
                            <input
                              id={`vnp-checkbox-${key}`}
                              className='form-check-input'
                              type='checkbox'
                              checked={expandedRepresentatives[key] || false}
                              onChange={() => toggleRepresentativeExpansion(key)}
                            />
                            <label
                              className='form-check-label'
                              htmlFor={`vnp-checkbox-${key}`}
                              style={{ cursor: 'pointer' }}
                            >
                              <b>VNP-{key.replace('representative-', '')}</b> - {rep.name}{' '}
                              {rep.firstName}
                            </label>
                          </div>
                          {expandedRepresentatives[key] && (
                            <div className='ms-4 mt-3 p-3 border rounded bg-light'>
                              <div className='mb-2'>
                                <strong>{t('Beziehung')}:</strong> {rep.relation}
                              </div>
                              <div className='mb-2'>
                                <strong>{t('name')}:</strong> {rep.name}
                              </div>
                              <div className='mb-2'>
                                <strong>{t('firstName')}:</strong> {rep.firstName}
                              </div>
                              <div className='mb-2'>
                                <strong>{t('address')}:</strong> {rep.address}
                              </div>
                              <div className='mb-2'>
                                <strong>{t('country')}:</strong> {rep.country}
                              </div>
                              <div className='mb-2'>
                                <strong>{t('birthPlace')}:</strong> {rep.birthPlace}
                              </div>
                              <div className='mb-2'>
                                <strong>{t('birthDate')}:</strong> {rep.birthDate}
                              </div>
                              <div className='mb-2'>
                                <strong>{t('nationality')}:</strong> {rep.nationality}
                              </div>
                              <div className='mb-2'>
                                <strong>{t('idNumber')}:</strong> {rep.idNumber}
                              </div>
                              <div className='mb-2'>
                                <strong>{t('authority')}:</strong> {rep.authority}
                              </div>
                              {rep.notes && (
                                <div className='mb-2'>
                                  <strong>{t('notes')}:</strong> {rep.notes}
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>

                    {/* b) */}
                    <div className='ms-4'>
                      <h5 className='fw-bold'>b) {t('identityVerification')}</h5>
                      <h5 className='fw-bold'> {t('identityHasBeenVerified')}</h5>
                      <div className='form-check mt-2'>
                        <input
                          id='idProof'
                          className='form-check-input'
                          type='checkbox'
                          name='idProof'
                          checked={formData.idProof}
                          onChange={handleInputChange}
                        />
                        <label
                          className='form-check-label'
                          htmlFor='idProof'
                          style={{ cursor: 'pointer' }}
                        >
                          &nbsp;{t('idProof')}
                        </label>
                      </div>
                      <div className='form-check mt-2'>
                        <input
                          id='electronicIdProof'
                          className='form-check-input'
                          type='checkbox'
                          name='electronicIdProof'
                          checked={formData.electronicIdProof}
                          onChange={handleInputChange}
                        />
                        <label
                          className='form-check-label'
                          htmlFor='electronicIdProof'
                          style={{ cursor: 'pointer' }}
                        >
                          &nbsp;{t('electronicIdProof')}
                        </label>
                      </div>
                      <div className='form-check mt-2'>
                        <input
                          id='otherProof'
                          className='form-check-input'
                          type='checkbox'
                          name='otherProof'
                          checked={formData.otherProof}
                          onChange={handleInputChange}
                        />
                        <label
                          className='form-check-label'
                          htmlFor='ownDootherProofcumented'
                          style={{ cursor: 'pointer' }}
                        >
                          &nbsp;{t('otherProof')}
                        </label>
                      </div>
                    </div>
                  </div>
                  <h5 className='mt-4 fw-bold'>B. {t('identificationBeneficialOwners')}</h5>
                  {/* B 1 */}
                  <div className='ms-4'>
                    <h5 className='fw-bold'>1. {t('legalEntitiesAndUnlistedCompanies')}</h5>
                    <div className='ms-4 mt-2'>
                      <span> {t('shareHolder')}</span>
                    </div>
                    <div className='ms-4'>
                      <textarea
                        className='w-100'
                        id='shareHolder'
                        name='shareHolder'
                        value={formData.shareHolder}
                        onChange={handleTextAreaChanged}
                      />
                    </div>
                    <div className='ms-4 mt-3'>
                      {(() => {
                        const selected = formData.beneficialOwnerSelection

                        const handleRadioChange = (value: string) => {
                          const updated = { ...formData, beneficialOwnerSelection: value }
                          setFormData(updated)
                          if (saveTimeoutRef.current) clearTimeout(saveTimeoutRef.current)
                          saveTimeoutRef.current = setTimeout(() => autoSave(updated), 600)
                        }

                        return (
                          <>
                            <div className='form-check' style={{ position: 'relative', zIndex: 1 }}>
                              <input
                                className='form-check-input'
                                type='radio'
                                name='beneficialOwnersExist'
                                id='noRegisteredBeneficialOwner'
                                value='noRegistered'
                                checked={selected === 'noRegistered'}
                                onChange={() => handleRadioChange('noRegistered')}
                              />
                              <label
                                className='form-check-label'
                                htmlFor='noRegisteredBeneficialOwner'
                                style={{ cursor: 'pointer' }}
                              >
                                {t('noRegisteredBeneficialOwner')}
                              </label>
                            </div>
                            <div
                              className='form-check mt-2'
                              style={{ position: 'relative', zIndex: 1 }}
                            >
                              <input
                                className='form-check-input'
                                type='radio'
                                name='beneficialOwnersExist'
                                id='noBeneficialOwners'
                                value='noBeneficial'
                                checked={selected === 'noBeneficial'}
                                onChange={() => handleRadioChange('noBeneficial')}
                              />
                              <label
                                className='form-check-label'
                                htmlFor='noBeneficialOwners'
                                style={{ cursor: 'pointer' }}
                              >
                                {t('noBeneficialOwners')}
                              </label>
                            </div>
                            <div
                              className='form-check mt-2'
                              style={{ position: 'relative', zIndex: 1 }}
                            >
                              <input
                                className='form-check-input'
                                type='radio'
                                name='beneficialOwnersExist'
                                id='hasBeneficialOwners'
                                value='hasBeneficial'
                                checked={selected === 'hasBeneficial'}
                                onChange={() => handleRadioChange('hasBeneficial')}
                              />
                              <label
                                className='form-check-label'
                                htmlFor='hasBeneficialOwners'
                                style={{ cursor: 'pointer' }}
                              >
                                {t('hasBeneficialOwners')}
                              </label>
                            </div>
                          </>
                        )
                      })()}
                    </div>
                    <div>
                      {!hasBeneficialOwnersLegalEntities ? (
                        <KButton
                          variant='primary'
                          icon='plus'
                          onClick={() => handleAddBeneficialOwner('legalEntities')}
                        />
                      ) : (
                        <>
                          {Object.entries(
                            beneficialOwnersLegalEntities as Record<string, BeneficialOwner>
                          ).map(([key, rep]) => (
                            <div key={key} className='mb-4'>
                              <div className='d-flex justify-content-between mb-2'>
                                <div className='mt-4'>
                                  <b>
                                    {t('beneficialOwner')}-
                                    <span>{key.replace('beneficial-owner-', '')}</span>
                                  </b>
                                  &nbsp;{t('representativeNaturalPerson')}
                                </div>
                                <KButton
                                  icon='trash'
                                  variant='danger'
                                  size='sm'
                                  onClick={() => handleDeleteBeneficialOwner(key, 'legalEntities')}
                                />
                              </div>
                              <Row>
                                <Col md={6}>
                                  <div className='mb-2'>
                                    <label className='form-label' htmlFor='isPerson'>
                                      {t('naturalPerson')}
                                    </label>
                                    &nbsp;
                                    <input
                                      id='isPerson'
                                      className='form-check-input'
                                      type='checkbox'
                                      name='isPerson'
                                      checked={rep.isPerson}
                                      onChange={e =>
                                        handleBeneficialOwnerChange(
                                          'legalEntities',
                                          key,
                                          'isPerson',
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </Col>
                                <Col md={12}>
                                  <div className='mb-2'>
                                    <input
                                      placeholder={t('nameBeneficial')}
                                      className='form-control form-control-sm bg-info2'
                                      type='text'
                                      value={rep.name}
                                      onChange={e =>
                                        handleBeneficialOwnerChange(
                                          'legalEntities',
                                          key,
                                          'name',
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </Col>
                                <Col md={12}>
                                  <div className='mb-2'>
                                    <input
                                      placeholder={t('firstName')}
                                      className='form-control form-control-sm bg-info2'
                                      type='text'
                                      value={rep.firstName}
                                      onChange={e =>
                                        handleBeneficialOwnerChange(
                                          'legalEntities',
                                          key,
                                          'firstName',
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </Col>
                                <Col md={12}>
                                  <div className='mb-2'>
                                    <Form.Select
                                      className='form-control form-control-sm bg-info2'
                                      value={rep.country}
                                      onChange={e =>
                                        handleBeneficialOwnerChange(
                                          'legalEntities',
                                          key,
                                          'country',
                                          e.target.value
                                        )
                                      }
                                    >
                                      <option label={t('chooseCountry')}></option>
                                      {options.map((option: any) => (
                                        <option key={option.value} value={option.value}>
                                          {t(option.label)}
                                        </option>
                                      ))}
                                    </Form.Select>
                                  </div>
                                </Col>
                                <Col md={6}>
                                  <div className='mb-2'>
                                    <div
                                      ref={el => {
                                        datePickerBeneficialOwnerBirthDateRef.current[key] = el
                                      }}
                                      style={{ position: 'relative' }}
                                    >
                                      <Form.Control
                                        size='sm'
                                        className='bg-info2'
                                        type='text'
                                        placeholder='DD.MM.YYYY'
                                        value={rep.birthDate || ''}
                                        onChange={e =>
                                          handleBeneficialOwnerChange(
                                            'legalEntities',
                                            key,
                                            'birthDate',
                                            sanitizeDDMMYYYYInput(e.target.value)
                                          )
                                        }
                                        onClick={() =>
                                          setDatePickerBeneficialOwnerBirthDate(prev => ({
                                            ...prev,
                                            [key]: true,
                                          }))
                                        }
                                      />

                                      <KDayPicker
                                        open={!!datePickerBeneficialOwnerBirthDate[key]}
                                        value={rep.birthDate}
                                        onSelect={date => {
                                          const formatted = formatDDMMYYYY(date)
                                          handleBeneficialOwnerChange(
                                            'legalEntities',
                                            key,
                                            'birthDate',
                                            formatted
                                          )
                                          setDatePickerBeneficialOwnerBirthDate(prev => ({
                                            ...prev,
                                            [key]: false,
                                          }))
                                        }}
                                      />
                                    </div>
                                  </div>
                                </Col>
                                <Col md={12}>
                                  <div className='mb-2'>
                                    <input
                                      placeholder={t('nationality')}
                                      className='form-control form-control-sm bg-info2'
                                      type='text'
                                      value={rep.nationality}
                                      onChange={e =>
                                        handleBeneficialOwnerChange(
                                          'legalEntities',
                                          key,
                                          'nationality',
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </Col>
                                <Col md={12}>
                                  <div className='mb-2'>
                                    <input
                                      placeholder={t('idNumber')}
                                      className='form-control form-control-sm bg-info2'
                                      type='text'
                                      value={rep.idNumber}
                                      onChange={e =>
                                        handleBeneficialOwnerChange(
                                          'legalEntities',
                                          key,
                                          'idNumber',
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </Col>
                                <Col md={12}>
                                  <div className='mb-2'>
                                    <input
                                      placeholder={t('authority')}
                                      className='form-control form-control-sm bg-info2'
                                      type='text'
                                      value={rep.authority}
                                      onChange={e =>
                                        handleBeneficialOwnerChange(
                                          'legalEntities',
                                          key,
                                          'authority',
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </Col>
                                <Col md={12}>
                                  <div className='mb-2'>
                                    <input
                                      placeholder={t('identityVerificationThrough')}
                                      className='form-control form-control-sm bg-info2'
                                      type='text'
                                      value={rep.identityVerificationThrough}
                                      onChange={e =>
                                        handleBeneficialOwnerChange(
                                          'legalEntities',
                                          key,
                                          'identityVerificationThrough',
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </Col>
                                <Col>
                                  <KButton
                                    className='btn-user-primary btn-sm bg-collapse'
                                    icon='justify'
                                    title={t('notes')}
                                    onClick={() => {
                                      setShowModal(true)
                                    }}
                                  />
                                  <KButton
                                    className='btn-user-primary btn-sm btn-spacing bg-collapse'
                                    icon='eye'
                                    title={t('view')}
                                    onClick={() => {
                                      getKycCheck(key)
                                    }}
                                  />
                                  <KButton
                                    id='shufaCheck'
                                    variant={getKycCheckVariant(rep.lastCheck, rep.risk)}
                                    type='button'
                                    icon='check'
                                    className='text-white btn-spacing'
                                    title={t('ds | kyc check')}
                                    onClick={() => {
                                      localStorage.setItem('representativeKey', key)
                                      localStorage.setItem('clientInfoId', formData.id)
                                      localStorage.setItem('clientId', clientId || '')
                                      localStorage.setItem('name', rep.name)
                                      localStorage.setItem('firstName', rep.firstName)
                                      localStorage.setItem('country', rep.country)
                                      localStorage.setItem('dateOfBirth', rep.birthDate ?? '')
                                      getAccess()
                                    }}
                                  ></KButton>
                                  <KButton
                                    variant={variantIdentity[key] || 'secondary'}
                                    className='text-white btn-spacing'
                                    icon='person-bounding-box'
                                    title={t('DS | Identity')}
                                    onClick={() => {
                                      localStorage.setItem('name', rep.name)
                                      localStorage.setItem('firstName', rep.firstName)
                                      localStorage.setItem('country', rep.country)
                                      localStorage.setItem('clientId', clientId || '')
                                      openIdentityModal(key, 'beneficialOwner')
                                    }}
                                  />
                                  <KButton
                                    className='btn-user-primary btn-sm btn-spacing bg-collapse'
                                    icon='folder2-open'
                                    title={t('documents')}
                                    onClick={() => {
                                      navigate(
                                        `/client/identity-documents/${clientId}/beneficialOwner/${key}`
                                      )
                                    }}
                                  />
                                  <Modal
                                    id='noticeModal'
                                    type={''}
                                    show={showModal}
                                    onHide={() => setShowModal(false)}
                                  >
                                    <Modal.Header closeButton className='bg-secondary'>
                                      <Modal.Title>{t('notice')}</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                      <textarea
                                        className='notice mt-3 bg-info2 w-100'
                                        placeholder={t('notice')}
                                        value={rep.notes}
                                        onChange={e =>
                                          handleBeneficialOwnerChange(
                                            'legalEntities',
                                            key,
                                            'notes',
                                            e.target.value
                                          )
                                        }
                                      />
                                    </Modal.Body>
                                    <Modal.Footer>
                                      <Button
                                        variant='secondary'
                                        onClick={() => setShowModal(false)}
                                      >
                                        {t('close') || 'Close'}
                                      </Button>
                                    </Modal.Footer>
                                  </Modal>
                                </Col>
                              </Row>
                            </div>
                          ))}
                          <KButton
                            variant='primary'
                            icon='plus'
                            onClick={() => handleAddBeneficialOwner('legalEntities')}
                          />
                          {/* TODO Isto ako za legal entities uraditi i za foundationsLegalCapacity i instigationPersons */}
                        </>
                      )}
                    </div>
                  </div>

                  {/* B 2 */}
                  <div className='ms-4 mt-4'>
                    <h5 className='fw-bold'>2. {t('legalyConstituted')}</h5>

                    <div className='ms-4 mt-3'>
                      <div
                        className='form-check'
                        style={{ position: 'relative', zIndex: 1, textTransform: 'none' }}
                      >
                        <label className='form-label' htmlFor='hasBeneficiialFoundations'>
                          {t('hasBeneficiialFoundations')}
                        </label>
                        &nbsp;
                        <input
                          id='hasBeneficiialFoundations'
                          className='form-check-input'
                          type='checkbox'
                          name='hasBeneficiialFoundations'
                          checked={hasBeneficialOwnersFoundations}
                        />
                      </div>
                    </div>
                    <div>
                      {!hasBeneficialOwnersFoundations ? (
                        <KButton
                          variant='primary'
                          icon='plus'
                          onClick={() => handleAddBeneficialOwner('foundations')}
                        />
                      ) : (
                        <>
                          {Object.entries(
                            beneficialOwnersFoundations as Record<string, BeneficialOwner>
                          ).map(([key, owner]) => (
                            <div key={key} className='mb-4'>
                              <div className='d-flex justify-content-between mb-2'>
                                <div className='mt-4'>
                                  <b>
                                    {t('beneficialOwner')}-
                                    <span>{key.replace('beneficial-owner-', '')}</span>
                                  </b>
                                  &nbsp;{t('representativeNaturalPerson')}
                                </div>
                                <KButton
                                  icon='trash'
                                  variant='danger'
                                  size='sm'
                                  onClick={() => handleDeleteBeneficialOwner(key, 'foundations')}
                                />
                              </div>
                              <Row>
                                <Col md={6}>
                                  <div className='mb-2'>
                                    <label className='form-label' htmlFor='isPerson'>
                                      {t('naturalPerson')}
                                    </label>
                                    &nbsp;
                                    <input
                                      id='isPerson'
                                      className='form-check-input'
                                      type='checkbox'
                                      name='isPerson'
                                      checked={owner.isPerson}
                                      onChange={e =>
                                        handleBeneficialOwnerChange(
                                          'foundations',
                                          key,
                                          'isPerson',
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </Col>
                                <Col md={12}>
                                  <div className='mb-2'>
                                    <input
                                      placeholder={t('nameBeneficial')}
                                      className='form-control form-control-sm bg-info2'
                                      type='text'
                                      value={owner.name}
                                      onChange={e =>
                                        handleBeneficialOwnerChange(
                                          'foundations',
                                          key,
                                          'name',
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </Col>
                                <Col md={12}>
                                  <div className='mb-2'>
                                    <input
                                      placeholder={t('firstName')}
                                      className='form-control form-control-sm bg-info2'
                                      type='text'
                                      value={owner.firstName}
                                      onChange={e =>
                                        handleBeneficialOwnerChange(
                                          'foundations',
                                          key,
                                          'firstName',
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </Col>
                                <Col md={12}>
                                  <div className='mb-2'>
                                    <Form.Select
                                      className='form-control form-control-sm bg-info2'
                                      value={owner.country}
                                      onChange={e =>
                                        handleBeneficialOwnerChange(
                                          'foundations',
                                          key,
                                          'country',
                                          e.target.value
                                        )
                                      }
                                    >
                                      <option label={t('country')}></option>
                                      {options.map((option: any) => (
                                        <option key={option.value} value={option.value}>
                                          {t(option.label)}
                                        </option>
                                      ))}
                                    </Form.Select>
                                  </div>
                                </Col>
                                <Col md={6}>
                                  <div className='mb-2'>
                                    <div
                                      ref={el => {
                                        datePickerBeneficialLegalBirthDateRef.current[key] = el
                                      }}
                                      style={{ position: 'relative' }}
                                    >
                                      <Form.Control
                                        size='sm'
                                        className='bg-info2'
                                        type='text'
                                        placeholder='DD.MM.YYYY'
                                        value={owner.birthDate || ''}
                                        onChange={e =>
                                          handleBeneficialOwnerChange(
                                            'foundations',
                                            key,
                                            'birthDate',
                                            sanitizeDDMMYYYYInput(e.target.value)
                                          )
                                        }
                                        onClick={() =>
                                          setDatePickerBeneficialLegalBirthDate(prev => ({
                                            ...prev,
                                            [key]: true,
                                          }))
                                        }
                                      />

                                      <KDayPicker
                                        open={!!datePickerBeneficialLegalBirthDate[key]}
                                        value={owner.birthDate}
                                        onSelect={date => {
                                          const formatted = formatDDMMYYYY(date)
                                          handleBeneficialOwnerChange(
                                            'foundations',
                                            key,
                                            'birthDate',
                                            formatted
                                          )
                                          setDatePickerBeneficialLegalBirthDate(prev => ({
                                            ...prev,
                                            [key]: false,
                                          }))
                                        }}
                                      />
                                    </div>
                                  </div>
                                </Col>
                                <Col md={12}>
                                  <div className='mb-2'>
                                    <input
                                      placeholder={t('nationality')}
                                      className='form-control form-control-sm bg-info2'
                                      type='text'
                                      value={owner.nationality}
                                      onChange={e =>
                                        handleBeneficialOwnerChange(
                                          'foundations',
                                          key,
                                          'nationality',
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </Col>
                                <Col md={12}>
                                  <div className='mb-2'>
                                    <input
                                      placeholder={t('idNumber')}
                                      className='form-control form-control-sm bg-info2'
                                      type='text'
                                      value={owner.idNumber}
                                      onChange={e =>
                                        handleBeneficialOwnerChange(
                                          'foundations',
                                          key,
                                          'idNumber',
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </Col>
                                <Col md={12}>
                                  <div className='mb-2'>
                                    <input
                                      placeholder={t('authority')}
                                      className='form-control form-control-sm bg-info2'
                                      type='text'
                                      value={owner.authority}
                                      onChange={e =>
                                        handleBeneficialOwnerChange(
                                          'foundations',
                                          key,
                                          'authority',
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </Col>
                                <Col md={12}>
                                  <div className='mb-2'>
                                    <input
                                      placeholder={t('identityVerificationThrough')}
                                      className='form-control form-control-sm bg-info2'
                                      type='text'
                                      value={owner.identityVerificationThrough}
                                      onChange={e =>
                                        handleBeneficialOwnerChange(
                                          'foundations',
                                          key,
                                          'identityVerificationThrough',
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </Col>
                                <Col>
                                  <KButton
                                    className='btn-user-primary btn-sm bg-collapse'
                                    icon='justify'
                                    title={t('notes')}
                                    onClick={() => {
                                      setShowModal(true)
                                    }}
                                  />
                                  <KButton
                                    className='btn-user-primary btn-sm btn-spacing bg-collapse'
                                    icon='eye'
                                    title={t('view')}
                                    onClick={() => {
                                      getKycCheck(key)
                                    }}
                                  />
                                  <KButton
                                    id='shufaCheck'
                                    variant={getKycCheckVariant(owner.lastCheck, owner.risk)}
                                    type='button'
                                    icon='check'
                                    className='text-white btn-spacing'
                                    title={t('ds | kyc check')}
                                    onClick={() => {
                                      localStorage.setItem('representativeKey', key)
                                      localStorage.setItem('clientInfoId', formData.id)
                                      localStorage.setItem('clientId', clientId || '')
                                      localStorage.setItem('name', owner.name)
                                      localStorage.setItem('firstName', owner.firstName)
                                      localStorage.setItem('country', owner.country)
                                      localStorage.setItem('dateOfBirth', owner.birthDate ?? '')
                                      getAccess()
                                    }}
                                  ></KButton>
                                  <KButton
                                    variant={variantIdentity[key] || 'secondary'}
                                    className='text-white btn-spacing'
                                    icon='person-bounding-box'
                                    title={t('DS | Identity')}
                                    onClick={() => {
                                      localStorage.setItem('name', owner.name)
                                      localStorage.setItem('firstName', owner.firstName)
                                      localStorage.setItem('country', owner.country)
                                      localStorage.setItem('clientId', clientId || '')
                                      openIdentityModal(key, 'beneficialOwner')
                                    }}
                                  />
                                  <KButton
                                    className='btn-user-primary btn-sm btn-spacing bg-collapse'
                                    icon='folder2-open'
                                    title={t('documents')}
                                    onClick={() => {
                                      navigate(
                                        `/client/identity-documents/${clientId}/beneficialOwner/${key}`
                                      )
                                    }}
                                  />
                                  <Modal
                                    id='noticeModal'
                                    type={''}
                                    show={showModal}
                                    onHide={() => setShowModal(false)}
                                  >
                                    <Modal.Header closeButton className='bg-secondary'>
                                      <Modal.Title>{t('notice')}</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                      <textarea
                                        className='notice mt-3 bg-info2 w-100'
                                        placeholder={t('notice')}
                                        value={owner.notes}
                                        onChange={e =>
                                          handleBeneficialOwnerChange(
                                            'foundations',
                                            key,
                                            'notes',
                                            e.target.value
                                          )
                                        }
                                      />
                                    </Modal.Body>
                                    <Modal.Footer>
                                      <Button
                                        variant='secondary'
                                        onClick={() => setShowModal(false)}
                                      >
                                        {t('close') || 'Close'}
                                      </Button>
                                    </Modal.Footer>
                                  </Modal>
                                </Col>
                              </Row>
                            </div>
                          ))}
                          <KButton
                            variant='primary'
                            icon='plus'
                            onClick={() => handleAddBeneficialOwner('foundations')}
                          />
                        </>
                      )}
                    </div>

                    <div className='ms-4 mt-2'>
                      <span> {t('shareHolder')}</span>
                    </div>
                    <div className='ms-4'>
                      <textarea
                        className='w-100'
                        id='shareHolderFoundations'
                        name='shareHolderFoundations'
                        value={formData.shareHolderFoundations}
                        onChange={handleTextAreaChanged}
                      />
                    </div>

                    <div className='mt-4'>
                      <b>{t('beneficialOwner')}</b>
                      <div className='form-check mt-2'>
                        <input
                          id='admin'
                          className='form-check-input'
                          type='checkbox'
                          name='admin'
                          checked={formData.beneficialOwners.naturalPersonRoles.admin}
                          onChange={handleInputChange}
                        />
                        <label
                          className='form-check-label'
                          htmlFor='admin'
                          style={{ cursor: 'pointer' }}
                        >
                          &nbsp;{t('naturalPersonRoleAdmin')}
                        </label>
                      </div>
                      <div className='form-check mt-2'>
                        <input
                          id='management_board'
                          className='form-check-input'
                          type='checkbox'
                          name='management_board'
                          checked={formData.beneficialOwners.naturalPersonRoles.management_board}
                          onChange={handleInputChange}
                        />
                        <label
                          className='form-check-label'
                          htmlFor='management_board'
                          style={{ cursor: 'pointer' }}
                        >
                          &nbsp;{t('naturalPersonRoleManagementBoard')}
                        </label>
                      </div>
                      <div className='form-check mt-2'>
                        <input
                          id='assets_distributed'
                          className='form-check-input'
                          type='checkbox'
                          name='assets_distributed'
                          checked={formData.beneficialOwners.naturalPersonRoles.assets_distributed}
                          onChange={handleInputChange}
                        />
                        <label
                          className='form-check-label'
                          htmlFor='assets_distributed'
                          style={{ cursor: 'pointer' }}
                        >
                          &nbsp;{t('naturalPersonRoleAssetsDistributed')}
                        </label>
                      </div>
                      <div className='form-check mt-2'>
                        <input
                          id='beneficiary'
                          className='form-check-input'
                          type='checkbox'
                          name='beneficiary'
                          checked={formData.beneficialOwners.naturalPersonRoles.beneficiary}
                          onChange={handleInputChange}
                        />
                        <label
                          className='form-check-label'
                          htmlFor='beneficiary'
                          style={{ cursor: 'pointer' }}
                        >
                          &nbsp;{t('naturalPersonRoleBeneficiary')}
                        </label>
                      </div>
                      <div className='form-check mt-2'>
                        <input
                          id='other'
                          className='form-check-input'
                          type='checkbox'
                          name='other'
                          checked={formData.beneficialOwners.naturalPersonRoles.other}
                          onChange={handleInputChange}
                        />
                        <label
                          className='form-check-label'
                          htmlFor='other'
                          style={{ cursor: 'pointer' }}
                        >
                          &nbsp;{t('naturalPersonRoleOther')}
                        </label>
                      </div>
                    </div>
                  </div>
                  {/* B 3 */}
                  <div className='ms-4 mt-4'>
                    <h5 className='fw-bold'>3. {t('beneficialOwnerOnTheBasisOfActing')}</h5>
                    <div className='mt-2'>
                      <b>{t('transactionsCarriedOut')}</b>
                    </div>
                    <Row className='mb-2'>
                      <div className='form-check form-check-inline'>
                        <input
                          id='instigationPersonsNo'
                          className='form-check-input'
                          type='checkbox'
                          readOnly
                          checked={!hasBeneficialOwnersInstigationPersons}
                        />
                        <label className='form-check-label' htmlFor='instigationPersonsNo'>
                          {t('no')}
                        </label>
                      </div>
                      <div className='form-check form-check-inline'>
                        <input
                          id='instigationPersonsYes'
                          className='form-check-input'
                          type='checkbox'
                          readOnly
                          checked={hasBeneficialOwnersInstigationPersons}
                        />
                        <label className='form-check-label' htmlFor='instigationPersonsYes'>
                          {t('yes')}
                        </label>
                      </div>
                    </Row>
                    <div>
                      {!hasBeneficialOwnersInstigationPersons ? (
                        <KButton
                          variant='primary'
                          icon='plus'
                          onClick={() => handleAddBeneficialOwner('instigationPersons')}
                        />
                      ) : (
                        <>
                          {Object.entries(
                            beneficialOwnersInstigationPersons as Record<string, BeneficialOwner>
                          ).map(([key, rep]) => (
                            <div key={key} className='mb-4'>
                              <div className='d-flex justify-content-between mb-2'>
                                <div className='mt-4'>
                                  <b>
                                    {t('beneficialOwner')}-
                                    <span>{key.replace('beneficial-owner-', '')}</span>
                                  </b>
                                  &nbsp;{t('representativeNaturalPerson')}
                                </div>
                                <KButton
                                  icon='trash'
                                  variant='danger'
                                  size='sm'
                                  onClick={() =>
                                    handleDeleteBeneficialOwner(key, 'instigationPersons')
                                  }
                                />
                              </div>
                              <Row>
                                <Col md={6}>
                                  <div className='mb-2'>
                                    <label className='form-label' htmlFor='isPerson'>
                                      {t('naturalPerson')}
                                    </label>
                                    &nbsp;
                                    <input
                                      id='isPerson'
                                      className='form-check-input'
                                      type='checkbox'
                                      name='isPerson'
                                      checked={rep.isPerson}
                                      onChange={e =>
                                        handleBeneficialOwnerChange(
                                          'instigationPersons',
                                          key,
                                          'isPerson',
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </Col>
                                <Col md={12}>
                                  <div className='mb-2'>
                                    <input
                                      placeholder={t('nameBeneficial')}
                                      className='form-control form-control-sm bg-info2'
                                      type='text'
                                      value={rep.name}
                                      onChange={e =>
                                        handleBeneficialOwnerChange(
                                          'instigationPersons',
                                          key,
                                          'name',
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </Col>
                                <Col md={12}>
                                  <div className='mb-2'>
                                    <input
                                      placeholder={t('firstName')}
                                      className='form-control form-control-sm bg-info2'
                                      type='text'
                                      value={rep.firstName}
                                      onChange={e =>
                                        handleBeneficialOwnerChange(
                                          'instigationPersons',
                                          key,
                                          'firstName',
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </Col>
                                <Col md={12}>
                                  <div className='mb-2'>
                                    <Form.Select
                                      className='form-control form-control-sm bg-info2'
                                      value={rep.country}
                                      onChange={e =>
                                        handleBeneficialOwnerChange(
                                          'instigationPersons',
                                          key,
                                          'country',
                                          e.target.value
                                        )
                                      }
                                    >
                                      <option label={t('country')}></option>
                                      {options.map((option: any) => (
                                        <option key={option.value} value={option.value}>
                                          {option.label}
                                        </option>
                                      ))}
                                    </Form.Select>
                                  </div>
                                </Col>
                                <Col md={6}>
                                  <div className='mb-2'>
                                    <Col md={6}>
                                      <div
                                        ref={el => {
                                          datePickerInstigationBirthDateRef.current[key] = el
                                        }}
                                        className='mb-2'
                                        style={{ position: 'relative' }}
                                      >
                                        <Form.Control
                                          size='sm'
                                          className='bg-info2'
                                          type='text'
                                          placeholder='DD.MM.YYYY'
                                          value={rep.birthDate || ''}
                                          onChange={e =>
                                            handleBeneficialOwnerChange(
                                              'instigationPersons',
                                              key,
                                              'birthDate',
                                              sanitizeDDMMYYYYInput(e.target.value)
                                            )
                                          }
                                          onClick={() =>
                                            setDatePickerInstigationBirthDate(
                                              (prev: Record<string, boolean>) => ({
                                                ...prev,
                                                [key]: true,
                                              })
                                            )
                                          }
                                        />

                                        <KDayPicker
                                          open={!!datePickerInstigationBirthDate[key]}
                                          value={rep.birthDate}
                                          onSelect={date => {
                                            const formatted = formatDDMMYYYY(date)
                                            handleBeneficialOwnerChange(
                                              'instigationPersons',
                                              key,
                                              'birthDate',
                                              formatted
                                            )
                                            setDatePickerInstigationBirthDate(
                                              (prev: Record<string, boolean>) => ({
                                                ...prev,
                                                [key]: false,
                                              })
                                            )
                                          }}
                                        />
                                      </div>
                                    </Col>
                                  </div>
                                </Col>
                                <Col md={12}>
                                  <div className='mb-2'>
                                    <input
                                      placeholder={t('nationality')}
                                      className='form-control form-control-sm bg-info2'
                                      type='text'
                                      value={rep.nationality}
                                      onChange={e =>
                                        handleBeneficialOwnerChange(
                                          'instigationPersons',
                                          key,
                                          'nationality',
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </Col>
                                <Col md={12}>
                                  <div className='mb-2'>
                                    <input
                                      placeholder={t('idNumber')}
                                      className='form-control form-control-sm bg-info2'
                                      type='text'
                                      value={rep.idNumber}
                                      onChange={e =>
                                        handleBeneficialOwnerChange(
                                          'instigationPersons',
                                          key,
                                          'idNumber',
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </Col>
                                <Col md={12}>
                                  <div className='mb-2'>
                                    <input
                                      placeholder={t('authority')}
                                      className='form-control form-control-sm bg-info2'
                                      type='text'
                                      value={rep.authority}
                                      onChange={e =>
                                        handleBeneficialOwnerChange(
                                          'instigationPersons',
                                          key,
                                          'authority',
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </Col>
                                <Col md={12}>
                                  <div className='mb-2'>
                                    <input
                                      placeholder={t('identityVerificationThrough')}
                                      className='form-control form-control-sm bg-info2'
                                      type='text'
                                      value={rep.identityVerificationThrough}
                                      onChange={e =>
                                        handleBeneficialOwnerChange(
                                          'instigationPersons',
                                          key,
                                          'identityVerificationThrough',
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </Col>
                                <Col>
                                  <KButton
                                    className='btn-user-primary btn-sm bg-collapse'
                                    icon='justify'
                                    title={t('notes')}
                                    onClick={() => {
                                      setShowModal(true)
                                    }}
                                  />
                                  <KButton
                                    className='btn-user-primary btn-sm btn-spacing bg-collapse'
                                    icon='eye'
                                    title={t('view')}
                                    onClick={() => {
                                      getKycCheck(key)
                                    }}
                                  />
                                  <KButton
                                    id='shufaCheck'
                                    variant={getKycCheckVariant(rep.lastCheck, rep.risk)}
                                    type='button'
                                    icon='check'
                                    className='text-white btn-spacing'
                                    title={t('ds | kyc check')}
                                    onClick={() => {
                                      localStorage.setItem('representativeKey', key)
                                      localStorage.setItem('clientInfoId', formData.id)
                                      localStorage.setItem('clientId', clientId || '')
                                      localStorage.setItem('name', rep.name)
                                      localStorage.setItem('firstName', rep.firstName)
                                      localStorage.setItem('country', rep.country)
                                      localStorage.setItem('dateOfBirth', rep.birthDate ?? '')
                                      getAccess()
                                    }}
                                  ></KButton>
                                  <KButton
                                    variant={variantIdentity[key] || 'secondary'}
                                    className='text-white btn-spacing'
                                    icon='person-bounding-box'
                                    title={t('DS | Identity')}
                                    onClick={() => {
                                      localStorage.setItem('name', rep.name)
                                      localStorage.setItem('firstName', rep.firstName)
                                      localStorage.setItem('country', rep.country)
                                      localStorage.setItem('clientId', clientId || '')
                                      openIdentityModal(key, 'beneficialOwner')
                                    }}
                                  />
                                  <KButton
                                    className='btn-user-primary btn-sm btn-spacing bg-collapse'
                                    icon='folder2-open'
                                    title={t('documents')}
                                    onClick={() => {
                                      navigate(
                                        `/client/identity-documents/${clientId}/beneficialOwner/${key}`
                                      )
                                    }}
                                  />
                                  <Modal
                                    id='noticeModal'
                                    type={''}
                                    show={showModal}
                                    onHide={() => setShowModal(false)}
                                  >
                                    <Modal.Header closeButton className='bg-secondary'>
                                      <Modal.Title>{t('notice')}</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                      <textarea
                                        className='notice mt-3 bg-info2 w-100'
                                        placeholder={t('notice')}
                                        value={rep.notes}
                                        onChange={e =>
                                          handleBeneficialOwnerChange(
                                            'instigationPersons',
                                            key,
                                            'notes',
                                            e.target.value
                                          )
                                        }
                                      />
                                    </Modal.Body>
                                    <Modal.Footer>
                                      <Button
                                        variant='secondary'
                                        onClick={() => setShowModal(false)}
                                      >
                                        {t('close') || 'Close'}
                                      </Button>
                                    </Modal.Footer>
                                  </Modal>
                                </Col>
                              </Row>
                            </div>
                          ))}
                          <KButton
                            variant='primary'
                            icon='plus'
                            onClick={() => handleAddBeneficialOwner('instigationPersons')}
                          />
                        </>
                      )}
                    </div>
                  </div>

                  <h5 className='mt-4 fw-bold'>C. {t('politicallyExposedPersons')}</h5>
                  <div className='mb-2 form-check'>
                    <input
                      id='noOneConnected'
                      className='form-check-input'
                      type='checkbox'
                      name='noOneConnected'
                      checked={formData.noOneConnected}
                      onChange={handleInputChange}
                    />
                    <label htmlFor='noOneConnected'>{t('noOneConnected')}</label>&nbsp;
                  </div>

                  <div className='mb-2 form-check'>
                    <input
                      id='closeToPolitically'
                      className='form-check-input'
                      type='checkbox'
                      name='closeToPolitically'
                      checked={formData.closeToPolitically}
                      onChange={handleInputChange}
                    />
                    <label htmlFor='closeToPolitically'>{t('closeToPolitically')}</label>&nbsp;
                  </div>
                  <div className='mb-2'>
                    <div className='ms-4 mt-2'>
                      <span> {t('preciseDesignation')}</span>
                    </div>
                    <div className='ms-4'>
                      <textarea
                        className='w-100 bg-info2'
                        id='preciseDesignation'
                        name='preciseDesignation'
                        value={formData.preciseDesignation}
                        onChange={handleTextAreaChanged}
                      />
                    </div>
                  </div>
                  <h5 className='mt-4 fw-bold'>D. {t('highRiskCountries')}</h5>
                  <div className='mb-2 form-check'>
                    <input
                      id='notEstablishedInHighRiskCountry'
                      className='form-check-input'
                      type='checkbox'
                      name='notEstablishedInHighRiskCountry'
                      checked={formData.notEstablishedInHighRiskCountry}
                      onChange={handleInputChange}
                    />
                    <label htmlFor='notEstablishedInHighRiskCountry'>
                      {t('notEstablishedInHighRiskCountry')}
                    </label>
                    &nbsp;
                  </div>
                  <div className='mb-2 form-check'>
                    <input
                      id='establishedInHighRiskCountry'
                      className='form-check-input'
                      type='checkbox'
                      name='establishedInHighRiskCountry'
                      checked={formData.establishedInHighRiskCountry}
                      onChange={handleInputChange}
                    />
                    <label htmlFor='establishedInHighRiskCountry'>
                      {t('establishedInHighRiskCountry')}
                    </label>
                    &nbsp;
                  </div>
                  <div className='mb-2'>
                    <div className='ms-4 mt-2'>
                      <span> {t('thirdCountry')}</span>
                    </div>
                    <div className='ms-4'>
                      <textarea
                        className='w-100 bg-info2'
                        id='thirdCountry'
                        name='thirdCountry'
                        value={formData.thirdCountry}
                        onChange={handleTextAreaChanged}
                      />
                    </div>
                  </div>
                  <h5 className='mt-4 fw-bold'>E. {t('informationOnTheBusinessRelationship')}</h5>
                  <div className='mb-2 form-check'>
                    <input
                      id='purposeAndNatureClear'
                      className='form-check-input'
                      type='checkbox'
                      name='purposeAndNatureClear'
                      checked={formData.purposeAndNatureClear}
                      onChange={e => {
                        const updated = {
                          ...formData,
                          purposeAndNatureClear: e.target.checked,
                          purposeAndNatureDescription: e.target.checked
                            ? false
                            : formData.purposeAndNatureDescription,
                        }
                        setFormData(updated)
                        if (saveTimeoutRef.current) clearTimeout(saveTimeoutRef.current)
                        saveTimeoutRef.current = setTimeout(() => autoSave(updated), 600)
                      }}
                    />
                    <label htmlFor='purposeAndNatureClear'>{t('purposeAndNatureClear')}</label>
                    &nbsp;
                  </div>
                  <div className='mb-2 form-check'>
                    <input
                      id='purposeAndNatureDescription'
                      className='form-check-input'
                      type='checkbox'
                      name='purposeAndNatureDescription'
                      checked={formData.purposeAndNatureDescription}
                      onChange={e => {
                        const updated = {
                          ...formData,
                          purposeAndNatureDescription: e.target.checked,
                          purposeAndNatureClear: e.target.checked
                            ? false
                            : formData.purposeAndNatureClear,
                        }
                        setFormData(updated)
                        if (saveTimeoutRef.current) clearTimeout(saveTimeoutRef.current)
                        saveTimeoutRef.current = setTimeout(() => autoSave(updated), 600)
                      }}
                    />
                    <label htmlFor='purposeAndNatureDescription'>
                      {t('purposeAndNatureDescription')}
                    </label>
                    &nbsp;
                  </div>
                  <div className='mb-2'>
                    <div className='ms-4'>
                      <textarea
                        className='w-100 bg-info2'
                        id='purposeFurtherInfo'
                        name='purposeFurtherInfo'
                        value={formData.purposeFurtherInfo}
                        onChange={handleTextAreaChanged}
                      />
                    </div>
                  </div>
                  <h5 className='mt-4 fw-bold'>F. {t('furtherInformation')}</h5>
                  <div className='mb-2'>
                    <div className='ms-4'>
                      <textarea
                        className='w-100 bg-info2'
                        id='furtherInfo'
                        name='furtherInfo'
                        value={formData.furtherInfo}
                        onChange={handleTextAreaChanged}
                      />
                    </div>
                  </div>
                </Col>
              </Row>

              <Row className='mt-4'>
                <Col>
                  <h5 className='fw-bold'>{t('surveyFiles')}</h5>
                  <div className='mt-2 no-print'>
                    <input
                      ref={surveyFileInputRef}
                      type='file'
                      accept='.pdf,.txt,.xlsx,.doc,.docx'
                      className='d-none'
                      onChange={handleSurveyUpload}
                    />
                    <Button
                      variant='outline-primary'
                      size='sm'
                      disabled={surveyUploading}
                      onClick={() => surveyFileInputRef.current?.click()}
                    >
                      <i className='bi bi-upload me-1'></i>
                      {surveyUploading ? '...' : t('chooseFile')}
                    </Button>
                  </div>
                  {surveyFiles.length > 0 && (
                    <div className='mt-3'>
                      {surveyFiles.map((file, idx) => (
                        <div key={idx} className='d-flex align-items-center gap-2 mb-2'>
                          <span>{file.name}</span>
                          <Button
                            variant='outline-primary'
                            size='sm'
                            onClick={() =>
                              downloadKycFile(
                                clientId || '',
                                client?.name || '',
                                'survey_form',
                                file.name
                              )
                            }
                          >
                            <i className='bi bi-download'></i>
                          </Button>
                        </div>
                      ))}
                    </div>
                  )}
                </Col>
              </Row>

              <Row className='mt-4 mb-2 no-print'>
                <Col>
                  <div className='form-check form-switch'>
                    <input
                      id='isFinished'
                      className='form-check-input'
                      type='checkbox'
                      role='switch'
                      name='isFinished'
                      checked={formData.isFinished}
                      onChange={handleInputChange}
                    />
                    <label className='form-check-label fw-bold' htmlFor='isFinished'>
                      {t('surveyFormFinished')}
                    </label>
                  </div>
                </Col>
              </Row>
            </fieldset>

            {formData.isFinished && (
              <Row className='mt-2 mb-5 no-print'>
                <Col>
                  <Button variant='primary' onClick={handleGeneratePdf}>
                    <i className='bi bi-file-earmark-pdf me-2' />
                    {t('exportPDF')}
                  </Button>
                </Col>
              </Row>
            )}

            {access && (
              <KAccess
                show={access}
                pin={pin}
                pinRequired={pinRequired}
                onConfirm={(pin: any) => {
                  checkPin(pin)
                }}
                onClose={() => setAccess(false)}
                title={pinRequired ? t('pinCodeTitleSchufa') : t('confirmAction')}
              />
            )}
            {kycChecksNew && (
              <KycCkecks
                show={true}
                kyc={kycChecks}
                onClose={() => setKycChecksNew(false)}
                onDelete={
                  (kycNumber: number) => {}
                  // kycCheckDelete(kycNumber)
                }
              />
            )}
            {showModalIdentity && (
              <div className='App'>
                <IdentityModal
                  show={showModalIdentity}
                  onClose={() => {
                    setShowModalIdentity(false)
                  }}
                  onAccept={createIdentityRequest}
                  onDelete={removeIdentityRequest}
                  existingIdentity={identityRequests[identitySubjectId]}
                />
              </div>
            )}
          </main>
        </Row>
      </Container>
    </>
  )
}
